var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.trigger
        ? _c(
            "UiPopover",
            {
              ref: "popover",
              attrs: {
                zIndex: 100,
                trigger: _vm.trigger,
                containFocus: true,
                dropdownPosition: _vm.position,
                positionX: _vm.contextMenuPosition[0],
                positionY: _vm.contextMenuPosition[1],
                openOn: _vm.isContextMenu ? "manual" : "click",
                constrainToScrollParent: _vm.constrainToScrollParent,
              },
              on: { close: _vm.handleClose, open: _vm.handleOpen },
            },
            [
              _vm._t("header"),
              _c("UiMenu", {
                ref: "menu",
                attrs: {
                  options: _vm.options,
                  hasIcons: _vm.hasIcons,
                  maxWidth: _vm.maxWidth,
                },
                on: { select: _vm.handleSelection },
              }),
            ],
            2
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }